import { Collectible } from '../collectible';
import { Project } from '../project';

export type Tag = {
	id?: number;
	name: string;
	project?: Project;
	collectibles?: number[] | Collectible[];
};
